export enum EmployerSetupModes {
  employer = 'employer',
  partner = 'partner',
  distributor = 'distributor',
  subsidiary = 'subsidiary',
  system = 'system',
}
